import $ from 'jquery';
/**
 *
 * @param msg
 * @param type
 */
export const appendMessage = (msg, type = 'user', animate = true) => {
    const chatMessages = $('#chatMessages');
    const userMessageElement = document.createElement('div');
    userMessageElement.classList.add('message', type);
    userMessageElement.innerHTML = `<div>${preSanitize(msg)}</div>`;
    chatMessages.append(userMessageElement);
    animate &&
        $('#chatMessages').animate({
            scrollTop: $('#chatMessages')[0].scrollHeight
        }, 1000); // Animate the scroll inside the element
};
/**
 *
 * @returns
 */
export const isSteveTyping = () => $('.message.typing').length > 0;
/**
 *
 * @param _message
 * @returns
 */
export const preSanitize = (_message) => _message.replace('```html', '')
    .replace('```', '')
    .replace(/【\d+:\d+†source】/g, '')
    .trim();
